import { CurrencyFormat } from '@instinet-analytics/core-lib';
import { PortfolioItem } from 'portfolio/PortfolioItem';

export interface AggregationFieldPortfolioItem {
    ordinal: number;
    text: string;
    header?: (context: CurrencyFormat) => string;
}

export const aggregationFieldPortfolio: {
    [key in keyof PortfolioItem]?: AggregationFieldPortfolioItem;
} = {
    acct: { ordinal: 10, text: 'Account' },
    svol: { ordinal: 20, text: 'Adv', header: () => 'Adv (millions)' },
    liq: { ordinal: 30, text: '% Adv' },
    brokerName: { ordinal: 35, text: 'Broker' },
    client: { ordinal: 40, text: 'Client' },
    clientId: { ordinal: 50, text: 'Client ID' },
    clusterId: { ordinal: 54, text: 'Cluster ID' },
    clusterDescription: { ordinal: 56, text: 'Cluster Description' },
    name: { ordinal: 60, text: 'Company' },
    country: { ordinal: 70, text: 'Country' },
    curcy: { ordinal: 80, text: 'Currency' },
    desk: { ordinal: 90, text: 'Desk' },
    ex: { ordinal: 110, text: 'Exchange' },
    handler: { ordinal: 120, text: 'Handler' },
    idxEvtTrdCat: { ordinal: 125, text: 'Index Event' },
    sector: { ordinal: 130, text: 'Industry' },
    core: { ordinal: 140, text: 'Locale' },
    mcap: {
        ordinal: 150,
        text: 'Market Cap',
        header: (currencyFormat: CurrencyFormat) =>
            `Market Cap (${currencyFormat.prefix} billions)`,
    },
    dcat: { ordinal: 160, text: 'Order Date' },
    orderInfo: { ordinal: 170, text: 'Order Info' },
    state: { ordinal: 275, text: 'Order Status' },

    ownCat: { ordinal: 180, text: 'Owner Category' },
    basket: { ordinal: 190, text: 'Portfolio' },
    reg: { ordinal: 200, text: 'Region' },
    ind: { ordinal: 210, text: 'Sector' },
    secType: { ordinal: 220, text: 'Security Type' },
    side: { ordinal: 230, header: () => '', text: 'Side' },
    subInd: { ordinal: 240, text: 'Sub Industry' },
    symbol: { ordinal: 260, text: 'Symbol' },
    symbolIndex: { ordinal: 270, text: 'Symbol Index' },
    t0: { ordinal: 280, text: 'Tag 0' },
    t1: { ordinal: 290, text: 'Tag 1' },
    t2: { ordinal: 300, text: 'Tag 2' },
    t3: { ordinal: 310, text: 'Tag 3' },
    t4: { ordinal: 320, text: 'Tag 4' },
    t5: { ordinal: 330, text: 'Tag 5' },
    t6: { ordinal: 340, text: 'Tag 6' },
    t7: { ordinal: 350, text: 'Tag 7' },
    t8: { ordinal: 360, text: 'Tag 8' },
    t9: { ordinal: 370, text: 'Tag 9' },
    t10: { ordinal: 380, text: 'Tag 10' },
    t11: { ordinal: 390, text: 'Tag 11' },
    t12: { ordinal: 400, text: 'Tag 12' },
    t14: { ordinal: 420, text: 'Tag 14' },
    t15: { ordinal: 430, text: 'Tag 15' },
    t16: { ordinal: 440, text: 'Tag 16' },
    t17: { ordinal: 450, text: 'Tag 17' },
    t18: { ordinal: 460, text: 'Tag 18' },
    t19: { ordinal: 470, text: 'Tag 19' },
    t20: { ordinal: 480, text: 'Tag 20' },
    t21: { ordinal: 490, text: 'Tag 21' },
    t22: { ordinal: 500, text: 'Tag 22' },
    t23: { ordinal: 510, text: 'Tag 23' },
    t24: { ordinal: 520, text: 'Tag 23' },
    wheelStrategy: { ordinal: 530, text: 'Trade Strategy' },
    owner: { ordinal: 600, text: 'Trader' },
};

export type AggregationField = Extract<
    keyof typeof aggregationFieldPortfolio,
    string
>;
